/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './search-bar.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../app/record-editor/search-bar/search-bar.component';
import * as i4 from '@angular/forms';
import * as i5 from '@angular/router';
import * as i6 from '../../../../app/core/services/global-app-state.service';
import * as i7 from '../../../../app/core/services/record-search.service';
import * as i8 from '../../../../app/core/services/save-preview-modal.service';
const styles_SearchBarComponent:any[] = [i0.styles];
export const RenderType_SearchBarComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SearchBarComponent,data:{}});
function View_SearchBarComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),1,'span',[['class','result-text form-control-static']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['No results'])),(_l()(),i1.ɵted(-1,(null as any),['\n    ']))],
      (null as any),(null as any));
}
function View_SearchBarComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    ']))],(null as any),(null as any));
}
function View_SearchBarComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),8,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),0,'i',[['class','btn btn-default fa fa-chevron-left']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onPreviousClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),1,'span',[['class','result-text']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(5,(null as any),['',' / ',''])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵeld(7,0,(null as any),(null as any),0,'i',[['class',
          'btn btn-default fa fa-chevron-right']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onNextClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    ']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (_co.cursor + 1);
        const currVal_1:any = _co.resultCount;
        _ck(_v,5,0,currVal_0,currVal_1);
      });
}
function View_SearchBarComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),14,'div',[['class',
      'navbar-form col-md-5 inline']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),11,(null as any),(null as any),(null as any),(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(3,16384,(null as any),0,
      i2.NgSwitch,([] as any[]),{ngSwitch:[0,'ngSwitch']},(null as any)),(_l()(),i1.ɵted(-1,
      (null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_SearchBarComponent_2)),i1.ɵdid(6,278528,(null as any),0,
      i2.NgSwitchCase,[i1.ViewContainerRef,i1.TemplateRef,i2.NgSwitch],{ngSwitchCase:[0,
          'ngSwitchCase']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SearchBarComponent_3)),
      i1.ɵdid(9,278528,(null as any),0,i2.NgSwitchCase,[i1.ViewContainerRef,i1.TemplateRef,
          i2.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_SearchBarComponent_4)),i1.ɵdid(12,16384,(null as any),
          0,i2.NgSwitchDefault,[i1.ViewContainerRef,i1.TemplateRef,i2.NgSwitch],(null as any),
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.resultCount;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = 0;
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = 1;
    _ck(_v,9,0,currVal_2);
  },(null as any));
}
export function View_SearchBarComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),13,'div',[['class',
      'navbar-form input-group col-md-7 pull-left inline']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),5,'input',[['class',
      'form-control search'],['placeholder','Search records']],[[2,'ng-untouched',
      (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
      [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
      [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
      'keyup.enter'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
      'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i3.SearchBarComponent = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,3)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,3).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,3)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,3)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_4:any = ((<any>(_co.query = $event)) !== false);
      ad = (pd_4 && ad);
    }
    if (('keyup.enter' === en)) {
      const pd_5:any = ((<any>_co.searchOrGo()) !== false);
      ad = (pd_5 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(3,16384,(null as any),0,i4.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i4.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i4.DefaultValueAccessor]),i1.ɵdid(5,671744,(null as any),0,i4.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i4.NgControl,(null as any),[i4.NgModel]),i1.ɵdid(7,16384,(null as any),0,
          i4.NgControlStatus,[i4.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(9,0,(null as any),(null as any),
          3,'span',[['class','input-group-btn']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(11,0,(null as any),(null as any),0,'a',[['class','btn btn-default fa fa-search']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.SearchBarComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.searchOrGo()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SearchBarComponent_1)),
      i1.ɵdid(16,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i3.SearchBarComponent = _v.component;
    const currVal_7:any = _co.query;
    _ck(_v,5,0,currVal_7);
    const currVal_8:any = (_co.resultCount >= 0);
    _ck(_v,16,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,7).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,7).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,7).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,7).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,7).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,7).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,7).ngClassPending;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export function View_SearchBarComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-search-bar',
      ([] as any[]),(null as any),(null as any),(null as any),View_SearchBarComponent_0,
      RenderType_SearchBarComponent)),i1.ɵdid(1,245760,(null as any),0,i3.SearchBarComponent,
      [i5.ActivatedRoute,i5.Router,i1.ChangeDetectorRef,i6.GlobalAppStateService,i7.RecordSearchService,
          i8.SavePreviewModalService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SearchBarComponentNgFactory:i1.ComponentFactory<i3.SearchBarComponent> = i1.ɵccf('re-search-bar',
    i3.SearchBarComponent,View_SearchBarComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/record-editor/search-bar/search-bar.component.ngfactory.ts